<template>
  <b-card no-body>
    <!-- Header -->
    <b-card-header class="d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Active Sessions</h5>

      <b-button size="sm" variant="danger" @click="logoutAll">
        Logout All
      </b-button>
    </b-card-header>

    <!-- Body -->
    <b-card-body>
      <b-table
        responsive
        striped
        hover
        show-empty
        empty-text="No active sessions found"
        :items="devices"
        :fields="fields"
      >
        <!-- Device -->
        <template #cell(device)="data">
          <div class="d-flex align-items-center">
            <feather-icon
              :icon="data.item.icon"
              size="18"
              class="mr-75"
            />
            <div>
              <strong>{{ data.item.device }}</strong>

              <b-badge
                v-if="data.item.isCurrent"
                variant="success"
                class="ml-50"
              >
                Current
              </b-badge>

              <div class="text-muted font-small-2">
                {{ data.item.browser }} • {{ data.item.os }}
              </div>
            </div>
          </div>
        </template>

        <!-- Action -->
        <template #cell(action)="data">
          <b-button
            size="sm"
            variant="outline-danger"
            :disabled="data.item.isCurrent"
            @click="logoutDevice(data.item.id)"
          >
            Logout
          </b-button>
        </template>
      </b-table>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BButton,
  BBadge,
} from 'bootstrap-vue'

export default {
  name: 'LoggedInDevices',

  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BButton,
    BBadge,
  },

  data() {
    return {
      fields: [
        { key: 'device', label: 'Device' },
        {
          key: 'location',
          label: 'Location',
          formatter: (_, item) =>
            `${item.city || ''}, ${item.country || ''}`,
        },
        { key: 'lastActive', label: 'Last Active' },
        { key: 'action', label: 'Action' },
      ],

      devices: [
        {
          id: 'sess_001',
          device: 'MacBook Pro',
          browser: 'Chrome',
          os: 'macOS',
          city: 'Prayagraj',
          country: 'India',
          lastActive: 'Just now',
          icon: 'MonitorIcon',
          isCurrent: true,
        },
        {
          id: 'sess_002',
          device: 'iPhone 14',
          browser: 'Safari',
          os: 'iOS',
          city: 'Prayagraj',
          country: 'India',
          lastActive: '12 minutes ago',
          icon: 'SmartphoneIcon',
          isCurrent: false,
        },
        {
          id: 'sess_003',
          device: 'Windows Laptop',
          browser: 'Edge',
          os: 'Windows 11',
          city: 'Delhi',
          country: 'India',
          lastActive: '2 hours ago',
          icon: 'LaptopIcon',
          isCurrent: false,
        },
      ],
    }
  },

  methods: {
    logoutDevice(id) {
      this.devices = this.devices.filter(d => d.id !== id)
    },

    logoutAll() {
      // keep only current session
      this.devices = this.devices.filter(d => d.isCurrent)
    },
  },
}
</script>

<style scoped>
.font-small-2 {
  font-size: 12px;
}
</style>
